import _ from "lodash";
import React, { Component } from "react";
import { Div, Image, Text } from "atomize";
import ImageLazyLoad from "../common/ImageLazyLoad";
import ImageLink from "./ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

class VideoCard extends Component {
  // state = {
  //   turnCard: false,
  // }

  render() {
    // const { turnCard } = this.state
    const { card, ...rest } = this.props;

    return (
      <Div {...rest} cursor="pointer">
        <div>
          <Div pos="relative">
            <ImageLink link={_.get(card, "media[0].image.description")}>
              <ImageLazyLoad
                className="video-card image-card"
                bgImg={_.get(card, "media[0].image.file.url")}
                bgSize="cover"
                p={{ b: "120.3%" }}
                pos="relative"
              >
                {card.showRibbon && (
                  <Div
                    pos="absolute"
                    top="12px"
                    fontFamily="secondary"
                    textWeight="bold"
                    p={{ y: "10px", l: "13px", r: "19px" }}
                    bg="primary"
                    textColor="black"
                    className="card-label"
                  >
                    {card.ribbonLabel}
                  </Div>
                )}
                <Div
                  fontFamily="secondary"
                  pos="absolute"
                  bottom="0.75rem"
                  left="0.75rem"
                  w="calc(100% - 0.75rem)"
                  d="flex"
                  justify="space-between"
                >
                  <Div>
                    <Text
                      textSize="subheader2"
                      textColor="white"
                      textWeight="700"
                      style={{ lineHeight: "18px" }}
                    >
                      {/* {content.userName} */}
                      {card.postsCount} Posts
                    </Text>
                    <Text
                      textSize="tiny"
                      textColor="white"
                      m={{ t: "0.25rem" }}
                    >
                      For {card.companyName}
                    </Text>
                  </Div>
                  <ImageLink link={_.get(card, "companyLogo.description")}>
                    <Div
                      className="logo-icon"
                      bgImg={_.get(card, "companyLogo.file.url")}
                      bgSize="contain"
                      bgPos="center"
                      bgRepeat="no-repeat"
                      w="5.5rem"
                      h="2.25rem"
                      border="0.3rem solid"
                      borderColor="white"
                    ></Div>
                  </ImageLink>
                </Div>
                <Div
                  pos="absolute"
                  top="50%"
                  left="50%"
                  transform="translate(-50%, -50%)"
                >
                  <Image src="/images/play-btn.svg" h="3.5rem" w="3.5rem" />
                </Div>
              </ImageLazyLoad>
            </ImageLink>
          </Div>
        </div>
      </Div>
    );
  }
}

export default VideoCard;
